import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SubjectPlanType } from '../../../types/SubjectPlan';

const initialState:SubjectPlanType = {
    idTeacher: '',
    idClass: '',
    status: false,
    description: '',
    idCourse: '',
    level: 0,
    semester: 0,
    objectives: '',
    subjectReferences: '',
    assessmentCriteria: '',
    idSubject: '',
    idAcademicYear: ''
}

const subjectPlanSlice = createSlice({
  name: "subjectPlan",
  initialState,
  reducers: {
    setSubjectPlanData:(state, action:PayloadAction<SubjectPlanType>)=>({...state, ...action.payload}), 
    resetSubjectPlanData :()=>({...initialState})
  }
});

export const {setSubjectPlanData, resetSubjectPlanData} = subjectPlanSlice.actions

export default subjectPlanSlice.reducer